import BG from "../../../Images/sw.png";

const getResponsiveStyles = (screenSize, language) => {
  const { isMobile, isTablet, isSmallScreen } = screenSize;
  const isRTL = language === "ar";

  return {
    // Language Toggle Button
    languageToggle: {
      position: "fixed",
      top: isMobile ? "16px" : "24px",
      right: isRTL ? "auto" : isMobile ? "16px" : "30px",
      left: isRTL ? (isMobile ? "16px" : "30px") : "auto",
      zIndex: 1000,
      background: "rgba(255, 255, 255, 0.95)",
      backdropFilter: "blur(10px)",
      border: "2px solid #084d98",
      borderRadius: "12px",
      padding: isMobile ? "8px 16px" : "10px 20px",
      display: "flex",
      alignItems: "center",
      gap: "8px",
      cursor: "pointer",
      color: "#084d98",
      fontSize: isMobile ? "14px" : "15px",
      fontWeight: 600,
      boxShadow: "0 4px 12px rgba(8, 77, 152, 0.2)",
      transition: "all 0.3s ease",
      fontFamily: "inherit",
    },

    splashOverlay: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      background: "rgba(7, 11, 22, 0.94)",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: isMobile ? "18px" : "24px",
      zIndex: 1200,
      color: "#ffffff",
      padding: isMobile ? "24px" : "32px",
      textAlign: "center",
      backdropFilter: "blur(6px)",
    },

    splashImage: {
      maxWidth: isMobile ? "80%" : "60%",
      maxHeight: isMobile ? "40vh" : "50vh",
      borderRadius: "16px",
      boxShadow: "0 20px 45px rgba(15, 23, 42, 0.35)",
      border: "1px solid rgba(255, 255, 255, 0.25)",
      objectFit: "contain",
    },

    splashMessage: {
      fontSize: isMobile ? "15px" : "18px",
      fontWeight: 600,
      letterSpacing: "0.3px",
      maxWidth: "420px",
      lineHeight: 1.5,
    },

    container: {
      margin: 0,
      padding: isMobile ? "16px" : isTablet ? "20px" : "0",
      width: "100vw",
      height: "100vh",
      overflow: "hidden",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      position: "relative",
      fontFamily:
        "-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
      boxSizing: "border-box",
      direction: isRTL ? "rtl" : "ltr",
    },

    modalOverlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.6)",
      backdropFilter: "blur(8px)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 1000,
      padding: isMobile ? "16px" : "20px",
      animation: "fadeIn 0.3s ease",
    },

    modalContent: {
      background: "rgba(255, 255, 255, 0.98)",
      borderRadius: isMobile ? "20px" : "24px",
      boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.5)",
      width: "100%",
      maxWidth: isMobile ? "380px" : "460px",
      padding: isMobile ? "24px" : "32px",
      position: "relative",
      animation: "slideUp 0.3s ease",
      direction: isRTL ? "rtl" : "ltr",
    },

    modalCloseButton: {
      position: "absolute",
      top: isMobile ? "16px" : "20px",
      right: isRTL ? "auto" : isMobile ? "16px" : "20px",
      left: isRTL ? (isMobile ? "16px" : "20px") : "auto",
      background: "transparent",
      border: "none",
      color: "#6B7280",
      cursor: "pointer",
      padding: "8px",
      borderRadius: "8px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      transition: "all 0.2s",
    },

    modalHeader: {
      marginBottom: isMobile ? "20px" : "24px",
      paddingRight: isRTL ? "0" : "40px",
      paddingLeft: isRTL ? "40px" : "0",
    },

    modalTitle: {
      fontSize: isMobile ? "22px" : "26px",
      fontWeight: "700",
      color: "#084d98",
      margin: "0 0 8px 0",
    },

    modalSubtitle: {
      fontSize: isMobile ? "14px" : "15px",
      color: "#6B7280",
      margin: 0,
      lineHeight: "1.5",
    },

    modalForm: {
      display: "flex",
      flexDirection: "column",
      gap: isMobile ? "16px" : "20px",
    },

    modalInputGroup: {
      position: "relative",
    },

    modalLabel: {
      display: "block",
      fontSize: isMobile ? "14px" : "15px",
      fontWeight: "600",
      color: "#374151",
      marginBottom: "8px",
    },

    modalInputWrapper: {
      position: "relative",
      display: "flex",
      alignItems: "center",
    },

    modalIcon: {
      position: "absolute",
      left: isRTL ? "auto" : "14px",
      right: isRTL ? "14px" : "auto",
      color: "#084d98",
      width: "20px",
      height: "20px",
      pointerEvents: "none",
    },

    modalInput: {
      width: "100%",
      padding: isMobile ? "12px 16px 12px 44px" : "14px 18px 14px 48px",
      paddingLeft: isRTL
        ? isMobile
          ? "16px"
          : "18px"
        : isMobile
          ? "44px"
          : "48px",
      paddingRight: isRTL
        ? isMobile
          ? "44px"
          : "48px"
        : isMobile
          ? "16px"
          : "18px",
      fontSize: isMobile ? "15px" : "16px",
      border: "2px solid #E5E7EB",
      borderRadius: "12px",
      outline: "none",
      transition: "all 0.3s",
      backgroundColor: "#F9FAFB",
      color: "#1F2937",
      fontFamily: "inherit",
    },

    modalStatusMessage: {
      padding: isMobile ? "12px" : "14px",
      borderRadius: "12px",
      fontSize: isMobile ? "14px" : "15px",
      display: "flex",
      alignItems: "flex-start",
      gap: "10px",
      lineHeight: "1.5",
    },

    modalSuccessMessage: {
      backgroundColor: "#ECFDF5",
      border: "1px solid #A7F3D0",
      color: "#065F46",
    },

    modalErrorMessage: {
      backgroundColor: "#FEF2F2",
      border: "1px solid #FECACA",
      color: "#991B1B",
    },

    modalButtonGroup: {
      display: "flex",
      gap: isMobile ? "10px" : "12px",
      marginTop: isMobile ? "8px" : "12px",
    },

    modalButton: {
      flex: 1,
      padding: isMobile ? "12px" : "14px",
      fontSize: isMobile ? "15px" : "16px",
      fontWeight: "600",
      borderRadius: "12px",
      border: "none",
      cursor: "pointer",
      transition: "all 0.2s",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "8px",
      fontFamily: "inherit",
    },

    modalPrimaryButton: {
      backgroundColor: "#084d98",
      color: "white",
    },

    modalSecondaryButton: {
      backgroundColor: "#F3F4F6",
      color: "#374151",
    },

    backgroundImage: {
      position: "absolute",
      inset: "0",
      backgroundImage: `url(${BG})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      opacity: isMobile ? 0.7 : 1,
      pointerEvents: "none",
    },

    backgroundDecor: {
      position: "absolute",
      inset: "0",
      overflow: "hidden",
      pointerEvents: "none",
    },

    loginCard: {
      position: "relative",
      background: "rgba(255, 255, 255, 0.1)",
      backdropFilter: "blur(20px)",
      borderRadius: isMobile ? "16px" : "24px",
      boxShadow: isMobile
        ? "0 15px 35px -8px rgba(0,0,0,0.3), inset 0 1px 0 rgba(255,255,255,0.2)"
        : "0 25px 50px -12px rgba(0,0,0,0.4), inset 0 1px 0 rgba(255,255,255,0.2)",
      border: "1px solid rgba(255, 255, 255, 0.15)",
      padding: isMobile ? "24px 20px" : isTablet ? "28px 24px" : "32px",
      width: "100%",
      maxWidth: isMobile ? "340px" : isTablet ? "380px" : "420px",
      maxHeight: isMobile && isSmallScreen ? "90vh" : "none",
      overflowY: isMobile && isSmallScreen ? "auto" : "visible",
      zIndex: 2,
      margin: isMobile ? "auto" : "0",
    },

    header: {
      textAlign: "center",
      marginBottom: isMobile ? "20px" : isTablet ? "24px" : "28px",
    },

    logo: {
      width: isMobile ? "100px" : isTablet ? "120px" : "140px",
      height: isMobile ? "100px" : isTablet ? "120px" : "140px",
      borderRadius: "50%",
      margin: isMobile ? "0 auto 12px" : "0 auto 16px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      overflow: "hidden",
    },

    logoImg: {
      width: "110%",
      height: "250%",
      objectFit: "contain",
      transform: "translate(3px, 5px)",
    },

    title: {
      fontSize: isMobile ? "22px" : isTablet ? "25px" : "28px",
      fontWeight: 800,
      color: "#084d98ff",
      margin: 0,
      textShadow: "0 2px 4px rgba(0,0,0,0.3)",
      lineHeight: 1.2,
    },

    subtitle: {
      color: "#084d98ff",
      fontSize: isMobile ? "13px" : "14px",
      marginTop: "6px",
      lineHeight: 1.4,
    },

    form: {
      display: "flex",
      flexDirection: "column",
      gap: isMobile ? "16px" : "20px",
    },

    fieldGroup: {
      position: "relative",
    },

    label: {
      display: "block",
      color: "#084d98ff",
      fontSize: isMobile ? "13px" : "14px",
      fontWeight: 600,
      marginBottom: isMobile ? "6px" : "8px",
    },

    inputWrapper: {
      border: "1px solid #084d98ff",
      borderRadius: "16px",
      position: "relative",
    },

    inputIcon: {
      position: "absolute",
      left: isRTL ? "auto" : isMobile ? "10px" : "12px",
      right: isRTL ? (isMobile ? "10px" : "12px") : "auto",
      top: "50%",
      transform: "translateY(-50%)",
      color: "#084d98ff",
      width: isMobile ? "18px" : "20px",
      height: isMobile ? "18px" : "20px",
      pointerEvents: "none",
      zIndex: 1,
    },

    input: {
      width: "100%",
      paddingLeft: isRTL
        ? isMobile
          ? "12px"
          : "14px"
        : isMobile
          ? "36px"
          : "44px",
      paddingRight: isRTL
        ? isMobile
          ? "36px"
          : "44px"
        : isMobile
          ? "12px"
          : "14px",
      paddingTop: isMobile ? "10px" : "12px",
      paddingBottom: isMobile ? "10px" : "12px",
      background: "rgba(255, 255, 255, 0.1)",
      border: "1px solid rgba(255, 255, 255, 0.2)",
      borderRadius: isMobile ? "10px" : "12px",
      color: "#084d98ff",
      fontSize: isMobile ? "15px" : "16px",
      outline: "none",
      transition: "all 0.3s ease",
      boxSizing: "border-box",
      fontFamily: "inherit",
    },

    inputPassword: {
      paddingRight: isRTL
        ? isMobile
          ? "36px"
          : "44px"
        : isMobile
          ? "36px"
          : "44px",
      paddingLeft: isRTL
        ? isMobile
          ? "36px"
          : "44px"
        : isMobile
          ? "36px"
          : "44px",
    },

    showPasswordBtn: {
      position: "absolute",
      right: isRTL ? "auto" : isMobile ? "8px" : "10px",
      left: isRTL ? (isMobile ? "8px" : "10px") : "auto",
      top: "50%",
      transform: "translateY(-50%)",
      background: "none",
      border: "none",
      color: "#084d98ff",
      cursor: "pointer",
      padding: "4px",
      transition: "color 0.2s",
      borderRadius: "4px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 2,
    },

    rememberSection: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      marginTop: "-6px",
      flexWrap: isMobile ? "wrap" : "nowrap",
      gap: isMobile ? "8px" : "0",
    },

    checkboxLabel: {
      display: "flex",
      alignItems: "center",
      gap: isMobile ? "6px" : "8px",
      cursor: "pointer",
      color: "#084d98ff",
      fontSize: isMobile ? "13px" : "14px",
      order: isMobile ? 2 : 1,
    },

    checkbox: {
      width: isMobile ? "16px" : "18px",
      height: isMobile ? "16px" : "18px",
      accentColor: "#084d98ff",
      cursor: "pointer",
      flexShrink: 0,
      outline: "2px solid #084d98ff",
      outlineOffset: "-2px",
    },

    forgotLink: {
      color: "#084d98ff",
      fontSize: isMobile ? "13px" : "14px",
      textDecoration: "none",
      transition: "color 0.2s",
      order: isMobile ? 1 : 2,
      whiteSpace: "nowrap",
    },

    error: {
      background: "rgba(254, 242, 242, 0.15)",
      border: "1px solid rgba(252, 165, 165, 0.3)",
      borderRadius: isMobile ? "10px" : "12px",
      padding: isMobile ? "10px" : "12px",
      color: "#ff6b6b",
      fontSize: isMobile ? "13px" : "14px",
      textAlign: "center",
      lineHeight: 1.4,
    },

    success: {
      background: "rgba(240, 253, 244, 0.15)",
      border: "1px solid rgba(167, 243, 208, 0.3)",
      borderRadius: isMobile ? "10px" : "12px",
      padding: isMobile ? "10px" : "12px",
      color: "#10b981",
      fontSize: isMobile ? "13px" : "14px",
      textAlign: "center",
      lineHeight: 1.4,
    },

    submitBtn: {
      width: "100%",
      background: "linear-gradient(135deg, #2e7cba, #084d98ff)",
      color: "white",
      padding: isMobile ? "10px 16px" : "12px 16px",
      borderRadius: isMobile ? "10px" : "12px",
      fontSize: isMobile ? "15px" : "16px",
      fontWeight: 700,
      border: "none",
      cursor: "pointer",
      transition: "all 0.2s",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "8px",
      transform: "scale(1)",
      minHeight: isMobile ? "44px" : "48px",
      fontFamily: "inherit",
    },
  };
};

export default getResponsiveStyles;